export function selectedMlbLineType(selectedTypes) {
  const value = String(Array.isArray(selectedTypes) ? selectedTypes[0] : selectedTypes || "regular").toLowerCase();
  return ["all", "regular", "goblin", "demon"].includes(value) ? value : "regular";
}

export function selectedMlbGameIds(selectedGames) {
  return [...new Set((Array.isArray(selectedGames) ? selectedGames : [])
    .map((key) => String(key || "").match(/^mlb:game:(.+)$/)?.[1] || "")
    .filter(Boolean))];
}

export function authoritativeMlbGameRows(games, lineType = "regular") {
  return (Array.isArray(games) ? games : []).map((game) => {
    const counts = game?.line_type_counts || {};
    const count = lineType === "all"
      ? Number(game?.projection_id_count || 0)
      : Number(counts[lineType] || 0);
    return {
      Sport: "MLB",
      "Game ID": String(game?.game_id || ""),
      Matchup: game?.matchup || "",
      "Home Team": game?.home_team || "",
      "Away Team": game?.away_team || "",
      "Game Date": game?.game_date || "",
      GameTime: game?.game_time || "",
      // Preserve the governed, timezone-bearing instant. Reconstructing this as
      // "YYYY-MM-DD h:mm AM" is implementation-dependent and is rejected by
      // mobile Safari, which left the cards populated but the Games index empty.
      "Game Start Timestamp": String(game?.game_start_timestamp || "").trim(),
      __projectionCount: count,
    };
  });
}

export function detailCacheKey(version, projectionId) {
  return `${String(version || "").trim()}:${String(projectionId || "").trim()}`;
}

export function projectionIdFor(row) {
  return String(row?.["Projection ID"] ?? row?.ProjectionID ?? row?.projection_id ?? "").trim();
}
